


































    import {Component, Vue} from 'vue-property-decorator';
    /*import {
        addArea,
        addAutoGroup,
        addDealership,
        addSearchDomain,
        deleteDealership,
        deleteDomain,
        getAreaList,
        getAssociatedAutoGroup,
        getAssociatedDealershipAreas,
        getAutoGroupList,
        getDealershipSearchPaths,
        getSearchDomains,
        listDealerships,
        searchByArea,
        searchByAutoGroup,
        searchByDealership,
        searchByDomainName,
        updateDealershipInformation
    } from "../../endpoints";
    import {Area, AutoGroup, Dealership, SearchDomain, SearchPath} from "../../types";
    import {buildDealershipLink} from "../../path";
    import Search from "../utility/Search.vue";
    import {serializeForm} from "../../util";*/
    import Dealerships from "@/components/entity-manager/Dealerships.vue";
    import Domains from "@/components/entity-manager/Domains.vue";
    import Areas from "@/components/entity-manager/Areas.vue";
    import AutoGroups from "@/components/entity-manager/AutoGroups.vue";

    Vue.component("v-dealerships", Dealerships);
    Vue.component("v-domains", Domains);
    Vue.component("v-areas", Areas);
    Vue.component("v-auto-groups", AutoGroups);

    @Component
    export default class DealershipManager extends Vue {

/*        availableDealerships: Dealership[] = [];
        availableDomains: SearchDomain[] = [];
        availableAreas: Area[] = [];
        availableAutoGroups: AutoGroup[] = [];

        currentDomainBeingEdited: SearchDomain | null = null;
        currentDomainBeingDeleted: SearchDomain | null = null;

        currentDealershipBeingEdited: Dealership | null = null;
        currentDealershipBeingDeleted: Dealership | null = null;

        addDealershipForm : {
            dealershipName: string;
            streetAddress: string;
            latitude: string;
            longitude: string;
            isActive: boolean;
            searchPaths: SearchPath[],
            areas: Area[],
            autoGroups: AutoGroup[],
            addAreaSelectedItem: null | { id: number, name: string },
            addAutoGroupSelectedItem: null | { id: number, name: string },
        } = {
            dealershipName: "",
            streetAddress: "",
            latitude: "",
            longitude: "",
            isActive: true,
            searchPaths: [],
            areas: [],
            autoGroups: [],
            addAreaSelectedItem: null,
            addAutoGroupSelectedItem: null
        };

        addSearchPathForm: {
            selectedDomainItem: { id: number, name: string },
            searchPath: string
        } = {
            selectedDomainItem: null,
            searchPath: ""
        };

        addDomainForm = {
            domainName: "",
            vehicleContainerClass: "",
            navigationNextClass: "",
            navigationMoreClass: ""
        };

        addAreaForm: {
            name: string;
        } = {
            name: ""
        };

        addAutoGroupForm: {
            name: string;
        } = {
            name: ""
        };

        showSearchPathForm: boolean = false;
        showDealershipAddAreaForm: boolean = false;
        showDealershipAddAutoGroupForm: boolean = false;

        submitted: boolean = false;

        loadingDealerships: boolean = false;
        loadingDomains: boolean = false;
        loadingAreas: boolean = false;
        loadingAutoGroups: boolean = false;

        mounted() {
            this.refreshDealershipList();
            this.refreshDomainList();
            this.refreshAreaList();
            this.refreshAutoGroupList();
        }

        async refreshDomainList(id?: number) {

            this.loadingDomains = true;

            const params = new URLSearchParams();

            if(id) {
                params.append("id", `${id}`);
            }

            this.availableDomains = await getSearchDomains(params.toString());

            this.loadingDomains = false;
        }

        async refreshDealershipList(id?: number) {

            this.loadingDealerships = true;

            const params = new URLSearchParams();

            if(id) {
                params.append("id", `${id}`);
            }

            this.availableDealerships = await listDealerships(params.toString());

            this.loadingDealerships = false;
        }

        async refreshAreaList(id?: number) {

            this.loadingAreas = true;

            const params = new URLSearchParams();

            if(id) {
                params.append("id", `${id}`);
            }

            this.availableAreas = await getAreaList(params.toString());

            this.loadingAreas = false;
        }

        async refreshAutoGroupList(id?: number) {

            this.loadingAutoGroups = true;

            const params = new URLSearchParams();

            if(id) {
                params.append("id", `${id}`);
            }

            this.availableAutoGroups = await getAutoGroupList(params.toString());

            this.loadingAutoGroups = false;
        }

        onAddDealershipAutoGroupInput(result) {
            this.addDealershipForm.addAutoGroupSelectedItem = result;
        }

        onAddDealershipAutoGroupSubmit() {
            this.addDealershipForm.autoGroups.push(this.addDealershipForm.addAutoGroupSelectedItem as any);
            this.addDealershipForm.addAutoGroupSelectedItem = null;
            this.showDealershipAddAutoGroupForm = false;
        }

        onAddDealershipAreaInput(result) {
            this.addDealershipForm.addAreaSelectedItem = result;
        }

        onAddDealershipAreaSubmitf() {
            this.addDealershipForm.areas.push(this.addDealershipForm.addAreaSelectedItem as any);
            this.addDealershipForm.addAreaSelectedItem = null;
            this.showDealershipAddAreaForm = false;
        }

        onAddSearchPathResultClicked(result) {
            this.addSearchPathForm.selectedDomainItem = result;
        }

        onDomainSearchResultSelected(result) {
            this.refreshDomainList(result ? result.id : null);
        }

        onDealershipResultSelected(result) {
            this.refreshDealershipList(result ? result.id : null);
        }

        onSearchAreaFilterInput(result) {
            this.refreshAreaList(result ? result.id : null);
        }

        onSearchAutoGroupInput(result) {
            this.refreshAutoGroupList(result ? result.id : null);
        }

        onAddSearchPathSubmissionButtonClick() {

            if(!this.isAddSearchPathFormValid) {
                return;
            }

            this.addDealershipForm.searchPaths.push({
                domain_id: this.addSearchPathForm.selectedDomainItem.id,
                host: this.addSearchPathForm.selectedDomainItem.name,
                uri: this.addSearchPathForm.searchPath
            });


            this.addSearchPathForm.searchPath = "";
            this.addSearchPathForm.selectedDomainItem = null;

            this.showSearchPathForm = false;
        }

        onAddDealershipDeleteSearchPathButtonClick(id: number) {
            this.addDealershipForm.searchPaths = this.addDealershipForm.searchPaths.filter(path => {
                return path.domain_id !== id
            });
        }

        onAddDealershipDeleteAreaButtonClick(id: number) {
            this.addDealershipForm.areas = this.addDealershipForm.areas.filter((area: any) => {
                return area.id !== id
            });
        }

        onAddDealershipDeleteAutoGroupButtonClick(id: number) {
            this.addDealershipForm.autoGroups = this.addDealershipForm.autoGroups.filter((group: any) => {
                return group.id !== id
            });
        }

        async onAddAreaSubmitButtonClick() {

            this.submitted = true;

            const payload = JSON.stringify(serializeForm(this.$refs['add-area-form'] as HTMLFormElement));

            try {
                await addArea(payload);

                this.refreshAreaList();

                (this.$refs['add-area-modal'] as any).hide();
            } catch (e) {
                console.error(e);
            } finally {
                this.submitted = false;
            }
        }

        async onEditDealershipButtonClick(dealership: Dealership) {

            this.currentDealershipBeingEdited = dealership;

            this.addDealershipForm.dealershipName = dealership.name;
            this.addDealershipForm.streetAddress = dealership.street_address;
            this.addDealershipForm.latitude = `${dealership.latitude}`;
            this.addDealershipForm.longitude = `${dealership.longitude}`;
            this.addDealershipForm.isActive = dealership.is_active;

            (this.$refs['add-dealership-modal'] as any).show();

            this.addDealershipForm.searchPaths = await getDealershipSearchPaths(dealership.id);
            this.addDealershipForm.areas = await getAssociatedDealershipAreas(dealership.id);
            this.addDealershipForm.autoGroups = await getAssociatedAutoGroup(dealership.id);
        }

        get isAddDealershipAutoGroupFormValid() {
            return this.addDealershipForm.addAutoGroupSelectedItem !== null;
        }

        get isAddDealershipAreaFormValid() {
            return this.addDealershipForm.addAreaSelectedItem !== null;
        }

        get isAddSearchPathFormValid() {
            return this.addSearchPathForm.selectedDomainItem !== null && this.addSearchPathForm.searchPath.length
        }

        get isValidVehicleContainerClass() {
            return this.addDomainForm.vehicleContainerClass.length > 0
        }

        get isValidDomainName() {
            return this.addDomainForm.domainName.match(/\S+\.\S+/) !== null;
        }

        get isValidDealershipName() {
            return this.addDealershipForm.dealershipName.length > 0;
        }

        get isValidLongitude() {
            return this.addDealershipForm.longitude.length > 0 && !isNaN(parseInt(this.addDealershipForm.longitude));
        }

        get isValidLatitude() {
            return this.addDealershipForm.latitude.length > 0 && !isNaN(parseInt(this.addDealershipForm.latitude));
        }

        get isValidAreaName() {
            return this.addAreaForm.name.length > 0;
        }

        get isValidAutoGroupName() {
            return this.addAutoGroupForm.name.length > 0;
        }

        onEditDomainButtonClick(domain: SearchDomain) {
            this.currentDomainBeingEdited = domain;

            this.addDomainForm.vehicleContainerClass = domain.vehicle_class;
            this.addDomainForm.domainName = domain.host;
            this.addDomainForm.navigationNextClass = domain.navigation_class_next;
            this.addDomainForm.navigationMoreClass = domain.navigation_class_more;

            (this.$refs['add-domain-modal'] as any).show();
        }

        onAddDealershipModalHidden() {
            if(this.currentDealershipBeingEdited) {
                this.currentDealershipBeingEdited = null;
            }

            this.addDealershipForm.dealershipName = "";
            this.addDealershipForm.streetAddress = "";
            this.addDealershipForm.longitude = "";
            this.addDealershipForm.latitude = "";
            this.addDealershipForm.isActive = true;
            this.addDealershipForm.searchPaths = [];
            this.addDealershipForm.areas = [];
            this.addDealershipForm.autoGroups = [];

            this.showSearchPathForm = false;
        }

        onAddDomainModalHidden() {

            if(this.currentDomainBeingEdited) {
                this.currentDomainBeingEdited = null;
            }

            this.addDomainForm.vehicleContainerClass = "";
            this.addDomainForm.domainName = "";
            this.addDomainForm.navigationNextClass = "";
            this.addDomainForm.navigationMoreClass = "";
        }

        onAddAreaModalHidden() {
            this.addAreaForm.name = "";
        }

        onAddAutoGroupModalHidden() {
            this.addAutoGroupForm.name = "";
        }

        async onAddAutoGroupSubmitButtonClick() {
            this.submitted = true;

            const payload = JSON.stringify(serializeForm(this.$refs['add-auto-group-form'] as HTMLFormElement));

            try {
                await addAutoGroup(payload);

                (this.$refs['add-auto-group-modal'] as any).hide();

                this.refreshAutoGroupList();
            } catch (e) {
                console.error(e);
            } finally {
                this.submitted = false;
            }
        }

        async onAddDealershipSubmitButtonClick() {

            this.submitted = true;

            let payload: any = {
                ...serializeForm(this.$refs['add-dealership-form'] as HTMLFormElement),
                search_paths: this.addDealershipForm.searchPaths,
                areas: this.addDealershipForm.areas,
                auto_groups: this.addDealershipForm.autoGroups
            };

            payload = JSON.stringify(payload);

            try {
                if(this.currentDealershipBeingEdited) {
                    await updateDealershipInformation(payload, this.currentDealershipBeingEdited.id);
                } else {
                    await addDealership(payload);
                }

                (this.$refs['add-dealership-modal'] as any).hide();

                this.refreshDealershipList();
            } catch (e) {
                console.error(e);
            } finally {
                this.submitted = false;
            }
        }

        async onAddDomainSubmitButtonClick() {

            if(!this.isValidDomainName || !this.isValidVehicleContainerClass) {
                return;
            }

            this.submitted = true;

            try {
                await addSearchDomain(JSON.stringify(serializeForm(this.$refs['add-domain-form'] as HTMLFormElement)));

                (this.$refs['add-domain-modal'] as any).hide();

                this.refreshDomainList();
            } catch (e) {
                console.error(e);
            } finally {
                this.submitted = false;
            }
        }

        onDeleteDealershipButtonClick(dealership: Dealership) {
            this.currentDealershipBeingDeleted = dealership;
            (this.$refs['delete-dealership-modal'] as any).show();
        }

        onDeleteDomainButtonClick(domain: SearchDomain) {
            this.currentDomainBeingDeleted = domain;
            (this.$refs['delete-domain-modal'] as any).show();
        }

        async onConfirmDealershipDelete() {

            this.submitted = true;

            try {
                await deleteDealership(this.currentDealershipBeingDeleted.id);

                this.refreshDealershipList();

                (this.$refs['delete-dealership-modal'] as any).hide();
            } catch (e) {
                console.error(e);
            } finally {
                this.submitted = false;
            }
        }

        async onConfirmDomainDelete() {

            this.submitted = true;

            try {
                await deleteDomain(this.currentDomainBeingDeleted.id);

                this.refreshDomainList();

                (this.$refs['delete-domain-modal'] as any).hide();
            } catch (e) {
                console.error(e);
            } finally {
                this.submitted = false;
            }
        }*/

    }
